import type { CommoditiesFormInput } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";

export const COMMODITIES_FORM_DEFAULT_VALUES: CommoditiesFormInput = {
	name: "",
	producer: "",
	product: "",
	contractNumber: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
	note: "",
};
